import EmailInvitationComponent from './email-invitation.vue'
export default EmailInvitationComponent
